/* ============================================================
   GPF MOTORSPORT — Moteur d'animations
   - Révélation au défilement (IntersectionObserver)
   - Header verre / transparent au-dessus du hero
   - Parallaxe légère
   - Transitions entre pages (rapides, compatibles bouton retour)
   - Curseur personnalisé (desktop uniquement)
   - Compteurs, carrousel véhicules, rotation 360
   Tout est désactivable via les réglages du thème et respecte
   prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';

  var body = document.body;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;
  var motionOK = body.classList.contains('gpf-motion') && !reducedMotion;

  /* ---------- Header ---------- */
  var headerSection = document.querySelector('.shopify-section-group-header-group sticky-header, sticky-header');
  headerSection = headerSection ? headerSection.closest('.shopify-section') : document.querySelector('.section-header');

  function setHeaderVar() {
    var h = headerSection ? headerSection.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--gpf-header-h', h + 'px');
  }
  setHeaderVar();
  window.addEventListener('resize', setHeaderVar);

  // Header transparent au-dessus du hero : uniquement si la page commence par un hero GPF
  var main = document.getElementById('MainContent');
  var firstSection = main ? main.querySelector('.shopify-section') : null;
  var hasHeroFirst = firstSection && firstSection.querySelector('.gpf-hero');
  if (hasHeroFirst && body.classList.contains('gpf-header-glass') && headerSection) {
    body.classList.add('gpf-overlay-header');
    var applyOverlay = function () {
      headerSection.style.marginBottom = '-' + headerSection.getBoundingClientRect().height + 'px';
      headerSection.style.position = 'relative';
      headerSection.style.zIndex = '5';
    };
    applyOverlay();
    window.addEventListener('resize', applyOverlay);
  }

  var lastScrolled = null;
  function onScrollHeader() {
    var scrolled = window.scrollY > 24;
    if (scrolled !== lastScrolled) {
      body.classList.toggle('gpf-scrolled', scrolled);
      lastScrolled = scrolled;
    }
  }
  onScrollHeader();
  window.addEventListener('scroll', onScrollHeader, { passive: true });

  /* ---------- Révélation au défilement ---------- */
  if (motionOK && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    document.querySelectorAll('.gpf-reveal, .gpf-reveal-mask, .gpf-lines').forEach(function (el) {
      io.observe(el);
    });

    // Cartes produits : uniquement celles sous la ligne de flottaison (pas de flash)
    var cards = document.querySelectorAll('.grid--peek .grid__item, #product-grid .grid__item');
    cards.forEach(function (el, i) {
      if (el.getBoundingClientRect().top > window.innerHeight) {
        el.classList.add('gpf-reveal');
        el.style.setProperty('--gpf-delay', (i % 4) * 0.06 + 's');
        io.observe(el);
      }
    });
  } else {
    document.querySelectorAll('.gpf-reveal, .gpf-reveal-mask, .gpf-lines').forEach(function (el) {
      el.classList.add('is-inview');
    });
  }

  /* ---------- Parallaxe légère ---------- */
  if (motionOK && !window.matchMedia('(max-width: 749px)').matches) {
    var pxItems = [];
    document.querySelectorAll('[data-gpf-parallax]').forEach(function (wrap) {
      var media = wrap.querySelector('.gpf-parallax-media');
      if (media) pxItems.push({ wrap: wrap, media: media, depth: parseFloat(wrap.dataset.gpfParallax) || 0.12 });
    });
    if (pxItems.length) {
      var ticking = false;
      var updateParallax = function () {
        ticking = false;
        var vh = window.innerHeight;
        pxItems.forEach(function (item) {
          var r = item.wrap.getBoundingClientRect();
          if (r.bottom < -100 || r.top > vh + 100) return;
          var progress = (r.top + r.height / 2 - vh / 2) / vh;
          item.media.style.setProperty('--gpf-shift', (progress * item.depth * -100).toFixed(1) + 'px');
        });
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(updateParallax); }
      }, { passive: true });
      updateParallax();
    }
  }

  /* ---------- Compteurs ---------- */
  if ('IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        cio.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat((el.dataset.gpfCounter || '0').replace(/\s/g, '')) || 0;
        if (!motionOK) { el.textContent = el.dataset.gpfCounterDisplay || el.dataset.gpfCounter; return; }
        var start = null;
        var dur = 1400;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased).toLocaleString('fr-FR');
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = el.dataset.gpfCounterDisplay || el.textContent;
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    document.querySelectorAll('[data-gpf-counter]').forEach(function (el) { cio.observe(el); });
  }

  /* ---------- Carrousel véhicules ---------- */
  document.querySelectorAll('[data-gpf-slider]').forEach(function (slider) {
    var track = slider.querySelector('.gpf-slider__track');
    var prev = slider.querySelector('[data-gpf-prev]');
    var next = slider.querySelector('[data-gpf-next]');
    var bar = slider.querySelector('.gpf-slider__progress-bar');
    if (!track) return;
    function slideBy(dir) {
      var item = track.querySelector('.gpf-slider__item');
      var w = item ? item.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * w, behavior: reducedMotion ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { slideBy(-1); });
    if (next) next.addEventListener('click', function () { slideBy(1); });
    if (bar) {
      track.addEventListener('scroll', function () {
        var max = track.scrollWidth - track.clientWidth;
        bar.style.width = (max > 0 ? (track.scrollLeft / max) * 100 : 100) + '%';
      }, { passive: true });
    }
  });

  /* ---------- Rotation 360 (séquence d'images) ---------- */
  document.querySelectorAll('[data-gpf-360]').forEach(function (stage) {
    var frames = Array.prototype.slice.call(stage.querySelectorAll('.gpf-360__frame'));
    if (frames.length < 2) return;
    var current = 0;
    var dragging = false;
    var startX = 0;
    var startFrame = 0;
    var sensitivity = Math.max(4, Math.floor(stage.clientWidth / frames.length / 2));
    function show(i) {
      var idx = ((i % frames.length) + frames.length) % frames.length;
      if (idx === current) return;
      frames[current].classList.remove('is-active');
      frames[idx].classList.add('is-active');
      current = idx;
    }
    function pointerDown(e) {
      dragging = true;
      startX = (e.touches ? e.touches[0].clientX : e.clientX);
      startFrame = current;
      stage.classList.add('is-dragging');
    }
    function pointerMove(e) {
      if (!dragging) return;
      var x = (e.touches ? e.touches[0].clientX : e.clientX);
      show(startFrame + Math.round((x - startX) / sensitivity));
    }
    function pointerUp() { dragging = false; stage.classList.remove('is-dragging'); }
    stage.addEventListener('mousedown', pointerDown);
    window.addEventListener('mousemove', pointerMove);
    window.addEventListener('mouseup', pointerUp);
    stage.addEventListener('touchstart', pointerDown, { passive: true });
    stage.addEventListener('touchmove', pointerMove, { passive: true });
    stage.addEventListener('touchend', pointerUp);
  });

  /* ---------- Transitions entre pages ---------- */
  var transitionsOK = body.classList.contains('gpf-transitions') && !reducedMotion && !designMode && document.querySelector('.gpf-transition');

  if (transitionsOK) {
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var link = e.target.closest('a[href]');
      if (!link) return;
      if (link.target && link.target !== '_self') return;
      if (link.hasAttribute('download') || link.getAttribute('href').charAt(0) === '#') return;
      var url;
      try { url = new URL(link.href, window.location.href); } catch (err) { return; }
      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return;
      if (url.pathname.indexOf('/cart/add') !== -1 || url.pathname.indexOf('/checkout') !== -1) return;
      if (link.closest('.shopify-payment-button, .product-form, cart-drawer, .quick-add')) return;
      e.preventDefault();
      body.classList.add('gpf-leaving');
      window.setTimeout(function () { window.location.href = link.href; }, 320);
      // Sécurité : ne jamais bloquer la navigation
      window.setTimeout(function () { body.classList.remove('gpf-leaving'); }, 2500);
    });

    // Animation d'entrée + compatibilité bouton retour (bfcache)
    var enter = function () {
      body.classList.remove('gpf-leaving');
      body.classList.add('gpf-entering');
      window.setTimeout(function () { body.classList.remove('gpf-entering'); }, 500);
    };
    enter();
    window.addEventListener('pageshow', function (e) { if (e.persisted) enter(); });
  }

  /* ---------- Curseur personnalisé ---------- */
  var cursor = document.querySelector('.gpf-cursor');
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (cursor && fine && !reducedMotion && body.classList.contains('gpf-cursor-enabled')) {
    var cx = -100, cy = -100, tx = -100, ty = -100;
    var labelEl = cursor.querySelector('.gpf-cursor__label');
    document.addEventListener('mousemove', function (e) { tx = e.clientX; ty = e.clientY; }, { passive: true });
    (function loop() {
      cx += (tx - cx) * 0.22;
      cy += (ty - cy) * 0.22;
      cursor.style.transform = 'translate(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px)';
      requestAnimationFrame(loop);
    })();
    document.addEventListener('mouseover', function (e) {
      var labelled = e.target.closest('[data-gpf-cursor]');
      var interactive = e.target.closest('a, button, [role="button"], input, select, textarea, summary');
      cursor.classList.toggle('is-hover', !!interactive || !!labelled);
      if (labelled && labelEl) {
        labelEl.textContent = labelled.getAttribute('data-gpf-cursor');
        cursor.classList.add('has-label');
      } else {
        cursor.classList.remove('has-label');
      }
    });
  }
})();
